import React from 'react'
import { useSelector } from 'hooks/use-redux'
import { isDeviceTypePhone } from '@disco/state-management/selectors/app'
import ClipboardInput from 'components/common/clipboard-input'
import Button from 'components/ui/button'
import Flex from 'components/ui/flex'
import Stack from 'components/ui/stack'
import mixpanel from 'mixpanel-browser'

type ShowAddAnother = {
  name: string
  url: string
  duplicate: boolean
}
type Props = {
  objectId: number
  objectType: string
  showAddAnother: ShowAddAnother
  sendMixpanelEvent: (...args: Array<any>) => any
  onAddAnotherClick: (...args: Array<any>) => any
}
type MixpanelShare = {
  'Playlist ID'?: number
  'Track ID'?: number
  'Contact ID': string
}

const AnotherRecipient = (props: Props): React.ReactNode => {
  const isPhone = useSelector(isDeviceTypePhone)

  const handleCopy = () => {
    let mixpanelObj
    if (props.objectType === 'playlist') {
      mixpanelObj = { 'Playlist ID': props.objectId }
    } else {
      mixpanelObj = { 'Track ID': props.objectId }
    }
    const mixpanelProps: MixpanelShare = {
      ...mixpanelObj,
      'Contact ID': props.showAddAnother.url,
    }
    props.sendMixpanelEvent('Copy assign share url', mixpanelProps)
  }

  const clipboardInput = (
    <ClipboardInput
      readOnly
      value={props.showAddAnother.url}
      onCopy={handleCopy}
    />
  )
  const button = (
    <Button
      caption="Add another"
      onClick={props.onAddAnotherClick}
      fullWidth={isPhone}
      textCenter={isPhone}
    />
  )

  if (isPhone) {
    return (
      <Stack space="xsmall">
        <div>{clipboardInput}</div>
        <div>{button}</div>
      </Stack>
    )
  }

  return (
    <Flex>
      <Flex.Content>{clipboardInput}</Flex.Content>
      <div>{button}</div>
    </Flex>
  )
}

export default AnotherRecipient
